<template>
    <section class="slides-menu" :class="{switchcolor: switchColor}">
        <div class="wrap-menu">
            <div class="container">
                <ul>
                    <li v-for="(item, index) in items"
                        @mouseenter="enterItem($event, index)"
                        @mouseleave="leaveItem($event, index)"
                        @click.prevent="clickSlide(index)"
                        :class="{active: index === actualIndex}"
                    >
                        <a href="">
                            <span class="label">{{item.titre | removeBr}}</span>
                            <span class="symbol-wrap"><span class="symbol"></span></span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
    import $ from "jquery";
    import Menu from "../libs/menu";
    import {find, debounce} from "lodash";
    import Scrolling from "../libs/Scrolling"

    export default {
        props: {
            items: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                actualIndex: 0,
                slidesCount: 0,
                maxIndex: 0,
                transitionDuration: 300,
                deltaTimeout: 50,
                totalTimeout: 0,
                okWheelEvent: true,
                firstThrottle: true,
                switchColor: false,
                okTrackPadEvent:true
            };
        },
        watch: {
            actualIndex(newVal) {
                this.switchColor = this.items[newVal].menuBlanc
                if (newVal === 0) {
                    setTimeout(function () {
                        $("body").addClass("bleu")
                    }, this.transitionDuration)
                } else {
                    $("body").removeClass("bleu")
                }
            }
        },
        computed: {
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },
        },
        methods: {
            initHomeTransitions() {
                // For Chrome
                window.addEventListener("mousewheel", this.mouseWheelEvent);
                // For Firefox
                window.addEventListener("DOMMouseScroll", this.mouseWheelEvent);

                document.onkeydown = (e) => {
                    if (!event)
                        event = window.event;
                    var code = event.keyCode;
                    if (event.charCode && code == 0)
                        code = event.charCode;
                    switch (code) {
                        case 37:
                            // Key left.
                            this.slideManager("up")
                            event.preventDefault();
                            break;
                        case 38:
                            // Key up.
                            this.slideManager("up")
                            event.preventDefault();
                            break;
                        case 39:
                            // Key right.
                            this.slideManager("down")
                            event.preventDefault();
                            break;
                        case 40:
                            // Key down.
                            this.slideManager("down")
                            event.preventDefault()
                            break;
                    }
                };
            },
            mouseWheelEvent(e) {

                if (this.okTrackPadEvent){
                    this.handleWheelEvent(e);
                    this.okTrackPadEvent = false
                }
                this.reInitTrackPadEvent()


            },
            reInitTrackPadEvent: debounce(function () {
                this.okTrackPadEvent = true
            },300),
            handleWheelEvent(e){

                if (this.breakpointDownMd) {
                    return
                }

                var delta = e.wheelDelta ? e.wheelDelta : -e.detail;

                if (delta > 0) {
                    // Go Up
                    this.slideManager("up")
                } else {
                    // Go Down
                    this.slideManager("down")
                }
            },
            slideManager(direction, newIndex) {

                if ((direction === "down" && this.actualIndex === this.maxIndex) || (direction === "up" && this.actualIndex === 0)) {
                    return
                }

                if (this.okWheelEvent) {

                    if (direction === "up" && newIndex === undefined) {
                        // Go Up
                        this.slideUp()
                    }
                    if (direction === "down" && newIndex === undefined) {
                        // Go Down
                        this.slideDown()
                    }

                    if (!isNaN(newIndex) && direction === null) {
                        let direction = newIndex > this.actualIndex ? "down" : "up"

                        this.goToSlide(newIndex, direction)
                    }

                    this.okWheelEvent = false

                    setTimeout(() => {
                        this.okWheelEvent = true
                    }, this.totalTimeout)
                }

            },
            slideDown() {
                if (this.actualIndex === this.maxIndex) {
                    return
                }
                let nextIndex = this.actualIndex + 1;
                this.goToSlide(nextIndex, "down")
            },
            slideUp() {
                if (this.actualIndex === 0) {
                    return
                }
                let nextIndex = this.actualIndex - 1;
                this.goToSlide(nextIndex, "up")
            },
            initFirstSlide() {
                if (!this.$route.hash) {
                    this.initSlide(this.actualIndex)
                } else {

                    let hash = this.$route.hash;
                    hash = hash.substr(1);

                    let selectedSlide = find(this.items, (o, index) => {
                        return o.slug === hash
                    });

                    this.initSlide(selectedSlide.index)

                }
            },
            initSlide(targetIndex) {
                if (this.breakpointDownMd) {
                    targetIndex = 0 // mobile force first slide
                }
                // $(`section.rubrique-hp[data-index="${targetIndex}"]`).addClass('init')
                if (targetIndex === 0) {
                    $("body").addClass("bleu")
                }
                this.goToSlide(targetIndex, "up", true)
            },
            goToSlide(targetIndex, direction, firstInit = false) {
                if ((targetIndex === this.actualIndex) && !firstInit) {
                    return
                }

                Menu.closeMenu();
                let $lastSection = $(`section.rubrique-hp[data-index="${this.actualIndex}"]`);
                let $nextSection = $(`section.rubrique-hp[data-index="${targetIndex}"]`);
                $("nav.main-menu").removeClass("z-index");

                let goClass = direction === "up" ? "go-down" : "go-up"
                let initClass = direction === "up" ? "init-down" : "init-up"

                initClass += " init-anim"

                if (!firstInit) {
                    $lastSection.addClass(goClass);
                    $lastSection.removeClass("init init-anim");
                }

                $nextSection.addClass(initClass)
                setTimeout(function () {
                    $nextSection.addClass("enter")
                }, this.deltaTimeout)

                //Clear Classes
                setTimeout(() => {
                    if (!firstInit) {
                        $lastSection.removeClass("go-up go-down")
                    }
                    $nextSection.removeClass("init-up enter init-down")
                    $nextSection.addClass("init");
                    if (this.actualIndex !== 0) {
                        $("nav.main-menu").addClass("z-index");
                    }

                    // Stop all sub slides
                    let $rubriqueSwiper = $(".rubrique-hp.swiper")

                    if ($rubriqueSwiper.length) {
                        $rubriqueSwiper.each((index, swiper) => {
                            this.$root.$refs[swiper.id].stopAllSubSwiper()
                        })
                    }

                    // Start if first slide has subSlides
                    let $activeSwiperRubrique = $(".rubrique-hp.init.swiper")
                    if ($activeSwiperRubrique.length) {
                        this.$root.$refs[$activeSwiperRubrique[0].id].checkActiveSlideForAutoPlay()
                    }


                }, this.totalTimeout)



                this.actualIndex = targetIndex
                this.updateHash(targetIndex)

            },
            enterItem($event, index) {
                $($event.target).addClass("hover")
            },
            leaveItem($event, index) {
                $($event.target).removeClass("hover")
            },
            clickSlide(index) {
                this.slideManager(null, index)
            },
            updateHash(index) {
                if (index === 0) {
                    this.$router.push({hash: null})
                    return
                }
                this.$router.push({hash: this.items[index].slug})
            },
            initArrow() {
                $(".little-fleche").on("click", (event) => {
                    event.preventDefault()
                    if (this.breakpointDownMd) {
                        Scrolling.scrollTo("#" + this.items[1].slug, "easeInOutExpo", 800, -Scrolling.hauteurMenuMobile)
                    } else {
                        this.slideDown()
                    }
                })
            }
        },
        mounted() {
            if (this.breakpointDownMd && this.$route.hash) {
                let hash = this.$route.hash

                setTimeout(() => {
                    Scrolling.scrollTo(hash)
                }, 50)
            }
            let $sectionRubriques = $("section.rubrique-hp")
            this.slidesCount = $sectionRubriques.length;
            this.maxIndex = this.slidesCount - 1;
            this.transitionDuration = parseFloat($("#data-transition").css("transition-duration")) * 1000;
            this.totalTimeout = this.transitionDuration + this.deltaTimeout
            this.initFirstSlide()
            setTimeout(() => {
                this.initHomeTransitions()
            }, this.totalTimeout)
            this.initArrow()

        },
        destroyed() {
            // For Chrome
            window.removeEventListener("mousewheel", this.mouseWheelEvent);
            // For Firefox
            window.removeEventListener("DOMMouseScroll", this.mouseWheelEvent);

            $(".little-fleche").off("click")

            document.onkeydown = null;
        }
    };
</script>
